// extracted by mini-css-extract-plugin
module.exports = {"ImgSection":"ContactImgSection-module--ImgSection--q7GTU","Picture":"ContactImgSection-module--Picture--3obSA"};